import React, { FC, useState } from 'react';
import styles from './NavMenu.module.css';
import { INavItemProps } from "../../../../declarations/types";
import cn from "classnames";
import Dropdown from 'antd/lib/dropdown/dropdown';
import { MenuProps } from 'rc-menu/lib/Menu';
import { MenuInfo } from 'rc-menu/lib/interface';

export const NavItem: FC<INavItemProps> = ({
  isActive = false,
  shouldRender,
  route,
  label,
  icon,
  isDark,
  className,
  subItem
}) => {

  const [open, setOpen] = useState(false);

  if (!shouldRender) {
    return null;
  }

  const classes = cn(className, styles.commonsNavMenuItem, {
    [styles.commonsNavMenuItemActive]: isActive,
    [styles.commonsNavMenuItemNotActive]: !isActive,
  });

  const handleMenuClick: MenuProps['onClick'] = (e: MenuInfo) => {
    window.location.assign(
      new URL(route).origin + subItem[Number(e.key)].path
    )
  };

  const handleOpenChange = (flag: boolean) => {
    setOpen(flag);
  };

  const itemLabelTheme = isDark ? styles.itemLabelDark : styles.itemLabel;

  const elSubItem = (item: string) => {
    return (
      <div style={{ background: 'none', display: 'inline' }} onFocus={(e) => e.preventDefault()}>
        <span style={{fontSize: '16px', float: 'left', color: '#6F7C98'}}>{item && item}</span>
      </div>
    )
  }

  const elItem = (
    <a href={route} className={classes} onFocus={(e) => e.preventDefault()}>
      <span className={styles.itemIcon}>
        {icon && icon}
      </span>
      <span className={itemLabelTheme}>{label && label}</span>
    </a>
  )

  const items: MenuProps['items'] = subItem.map((item, idx) => {
    return (
      {
        label: elSubItem(item.title),
        key: String(idx)
      }
    )
  })

  if (subItem.length) {
    return (
      <>
        <Dropdown
          menu={{
            items,
            onClick: handleMenuClick,
          }}
          onOpenChange={handleOpenChange}
          open={open}
          overlayStyle={{maxWidth: '170px'}}
        >
          {elItem}
        </Dropdown>
      </>
    );
  }

  return (
    <>
      {elItem}
    </>
  );
};
